import { Ifilter } from "./filter";

export interface IDataTablet {
   total: string;
   data: ITablet[];
}
export interface ITablet {
   dispositivosId: string;
   fabricante: string;
   modelo: string;
   marca: string;
   fechaRegistro: string;
   codigo: string;
}

export interface IPersonaTablets {
   personaId: string;
   dispositivoId: string;
}

export interface ISuplenteAdd {
   supervisorId: string;
   suplenteId: string;
   fechaInicio: string;
   fechaFin: string;
}

export interface IFilterEquipo extends Ifilter {
   supervisorId?: string | null;
}

export interface IFilterEquipoBySupervisor {
   skip: number;
   take: number;
   search: string | null;
   supervisorId?: string | null;
}

export interface IEquipoComboRequest extends Ifilter {
   equipoAuxiliar: boolean
}
export interface IEquipoRequest extends Ifilter {
   razonId?: string,
   turnoId?: string,
   ubicacionId?: string,
   equipoId?: string,
   estadoId?: string,
   tipoEquipoId?:string,
}

export const InitialEquipoRequest = {
   skip: 0,
   take: 50,
   search: ""
}

export interface IEquipoDTO {
   historicoEstadoEquipoId: string
   razonId: string
   razon: string
   turnoId: string
   turno: string
   ubicacionId: string
   ubicacion: string
   equipoId: string
   equipo: string
   equipoModeloId: string
   equipoModelo: string
   estadoId: string
   estado: string
   fechaCreacion: string
   horometro: number
   fecha: string
   comentario: string
   tipoEquipoId: string
   tipoEquipo: string
   equipoAuxiliar: boolean
   esVisible:boolean
   tieneHistorico: boolean;
}

export const InitialEquipoDTO = {
   historicoEstadoEquipoId: "",
   razonId: "",
   razon: "",
   turnoId: "",
   turno: "",
   ubicacionId: "",
   ubicacion: "",
   equipoId: "",
   equipo: "",
   equipoModeloId: "",
   equipoModelo: "",
   estadoId: "",
   estado: "",
   fechaCreacion: "",
   horometro: 0,
   fecha: "",
   comentario: "",
}
export interface IVisibilidad {
   equipoId:string,
   check:boolean
}

export interface IFilterEquipoModelo {
  search: string | null;
}

